import React from "react";
import ValueGenerationSection from './ValueGenerationSection';

const ValueGeneration = ({volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually}) => {
  return (
    <section className="UFOSEC excoSystemSec stakeSec StatsSec leftrightSecSpace">
      <div className="container">
        <div className="subcontent subPad SRTOP p-0">
          <div className="dateEco d-flex justify-content-between align-items-center">
            <div>
              <h2 className="goldFont mb-0" data-aos="fade-up" data-aos-delay="300" data-aos-duration="400">
                Value Generation
              </h2>
              <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="400">
                <p className="mb-0">Stay informed about UFO transaction fees applied.</p>
                <div className="perVal fInter d-flex align-items-center">
                  <span>All Transactions Incur a 6% fee.</span>
                </div>
              </div>
            </div>
          </div>
          <ValueGenerationSection
            volumeDaily={volumeDaily}
            volumeWeekly={volumeWeekly}
            volumeMonthly={volumeMonthly}
            volumeQuarterly={volumeQuarterly}
            volumeSemiAnnually={volumeSemiAnnually}
            volumeAnnually={volumeAnnually}
          />
        </div>
      </div>
    </section>
  );
};

export default ValueGeneration;
